// extracted by mini-css-extract-plugin
export default {"buttons":"OnlineJournal_buttons__OA6wy","postList":"OnlineJournal_postList__FIQwa","post":"OnlineJournal_post__EvOjD","postContent":"OnlineJournal_postContent__xlQR0"};